module.exports = __webpack_public_path__ + "static/media/light-wallet-link.4a4a27cb.svg";